import type { ReactNode } from 'react';

export const symbol_query_stats: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M63.06-431.41q-10.15-6.88-12.11-18.74Q49-462 55-472l135-217q16.23-26.25 46.12-28.13Q266-719 286-696l72 84 116-189q17.35-28.26 50.18-28.63Q557-830 575-803l73 109 126-199q6.55-10.91 19.27-13.45 12.73-2.55 23.62 5.7Q827-894 828.5-882.5T824-861L698-662q-17 28-49.5 28.5T598-660l-73-108-116 188q-15.85 25.61-46.43 27.8Q332-550 312-573l-71-83-135 216q-7 11-19.5 14t-23.44-5.41ZM582.79-220q48.21 0 82.71-33.49 34.5-33.5 34.5-82Q700-384 666.07-418q-33.93-34-83.07-34-48.3 0-81.65 34.5Q468-383 468-334.79q0 48.21 33.29 81.5t81.5 33.29Zm.21 60q-72.92 0-123.96-51.06-51.04-51.06-51.04-124T459.04-460q51.04-52 123.96-52 73.75 0 125.38 51.62Q760-408.75 760-335q0 29-8.5 54.5T727-233l91 90q9 9 9 21t-9 21q-9 9-21 9t-21-9l-91-91q-22 15-47.5 23.5T583-160Z"
		/>
	</svg>
);
